module.exports = __webpack_public_path__ + "static/media/399.908ffd88.png";